import { render, staticRenderFns } from "./EntregaForm.vue?vue&type=template&id=1bd039a1&"
import script from "./EntregaForm.vue?vue&type=script&lang=js&"
export * from "./EntregaForm.vue?vue&type=script&lang=js&"
import style0 from "./EntregaForm.vue?vue&type=style&index=0&id=1bd039a1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports